// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.2495 9.75C13.2495 9.05964 12.6899 8.5 11.9995 8.5C11.3092 8.5 10.7495 9.05964 10.7495 9.75V10.5H13.2495V9.75Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12 1C5.92487 1 1 5.92487 1 12C1 14.6615 1.94632 17.1038 3.51936 19.006L1.30049 23H12C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM15.2495 9.75V10.5H16.498V17H7.49805V10.5H8.74951V9.75C8.74951 7.95507 10.2046 6.5 11.9995 6.5C13.7944 6.5 15.2495 7.95508 15.2495 9.75Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-bubble-locked-filled')
export default class ChatBubbleLockedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-bubble-locked-filled',
    }
  }
}
